import React from 'react';

import styles from './RadarCard.module.scss';
import StatisticsCard from '../../../../Shared/StatisticsCard/StatisticsCard';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    RadialLinearScale,
    Filler
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
    scales: {
        r: {
            suggestedMin: 50,
            suggestedMax: 130,
            fill: 'origin',
            ticks: {
                stepSize: 20
            }
        }
    },
    datasets: {

    },
    elements: {
        point: {
            radius: 5,
        },
        line: {
            borderWidth: 1,
            borderColor: "#00000033",
            backgroundColor: "#68DB5A44",
        }
    }
};

function RadarCard(props: RadarCardProps) {
    return (
        <StatisticsCard
            title={props.title}
        >
            <div className={styles.cardcontent}>
                { props.data != undefined && props.data.datasets.length > 0 ?
                    <Radar
                        options={options}
                        data={props.data}
                        redraw={true}
                    ></Radar>
                : null }
                { props.description != undefined ?
                    <p className={styles.description}>{props.description}</p>
                : null }
            </div>
        </StatisticsCard>
    );
}

class RadarCardProps {
    title!: string;
    description?: string;
    data!: any;
}

export default RadarCard;